import { ASSESSMENTS, DATASETS, TENANT, VOLUNTEER_TAG_TYPE, isMadTenant } from "../madSettings";

export { ASSESSMENTS, TENANT };

/**
 * One line each: which dataset (see ../madSettings), which number field.
 */
const MAD = {
  volunteerTagType: VOLUNTEER_TAG_TYPE,
  datasets: {
    baselineAssessments: DATASETS.baselineAssessments,
    baselineAssessmentsFoundationalLiteracyP: DATASETS.baselineAssessmentsFoundationalLiteracyP,
  },
  series: [
    {
      key: "currentGrade",
      label: "Current grade",
      contentType: "baselineAssessments",
      valuePath: "main.baselineAssessments_selectTheGradeTheStudentIsIn_v1",
    },
    {
      key: "numeracyLevel",
      label: "Numeracy: learning level",
      contentType: "baselineAssessments",
      valuePath: "main.baselineAssessments_finalLearningGradeLevel_v1",
    },
    {
      key: "literacyLevel",
      label: "Literacy: learning level",
      contentType: "baselineAssessmentsFoundationalLiteracyP",
      valuePath: "main.baselineAssessmentsFoundationalLiteracyP_finalLearningGradeLevel_v1",
    },
    // Life Skills has no learning-level field on its template yet. Add its
    // dataset above and a line here once it does.
  ],
};

export const getTenantSettings = () => (isMadTenant() ? MAD : null);

/** Hook slots: one query per dataset, so the count is fixed up front. */
export const MAX_DATASETS = 4;
